export default __webpack_public_path__ + "static/media/comet.2552a63d.jpeg";